import styled from 'styled-components';
import { theme } from '../../../theme';

export const Wrapper = styled.div`
  align-items: center;
  background-color: ${props => props.theme.colors.sidebarBackground};
  border: thin solid ${props => props.theme.colors.cardBorderColor};
  border-radius: 4px;
  color: ${props => props.theme.colors.cardBorderColor};
  cursor: pointer;
  display: flex;
  justify-content: center;
  min-height: ${props => props.theme.space[6]}px;
  overflow: hidden;
  width: 100%;
  &:focus,
  &:hover {
    border: 0 ${theme.colors.primary};
    outline: none;
  }
  svg {
    height: 32px;
    pointer-events: none;
    position: absolute;
    width: 32px;
  }
`;

export const Preview = styled.img`
  height: auto;
  width: 100%;
`;
